import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  BooleanInput,
  required,
  email,
} from "react-admin";

const CreateAdministration = () => {
  return (
    <Create title="Създаване на потребител">
      <SimpleForm>
        <TextInput
          label="Име"
          source="first_name"
        />{" "}
        <TextInput
          label="Фамилия"
          source="last_name"
        />{" "}
        <TextInput
          label="Парола"
          source="password"
        />
        <TextInput
          label="Телефон"
          source="phone_number"
        />
        <TextInput
          label="E-мейл"
          source="email"
          validate={[required(), email()]}
        />
        <BooleanInput
          label="Лимитиран"
          source="is_limited_to_one_session "
        />
        <BooleanInput
          label="Блокиран"
          source="is_blocked"
        />
        <BooleanInput
          label="Администратор"
          source="is_administrator"
        />
        <ReferenceArrayInput
          source="role_ids"
          reference={"users/roles"}
        >
          <AutocompleteArrayInput
            optionText="name"
            label="Активни права"
            fullWidth
          />
        </ReferenceArrayInput>
      </SimpleForm>
    </Create>
  );
};

export default CreateAdministration;
